import { useApp } from '../../context/AppContext';
import { Button } from '../ui/button';
import { ThemeToggle } from './ThemeToggle';
import { LanguageToggle } from './LanguageToggle';
import { CurrencyToggle } from './CurrencyToggle';
import { Calculator, ArrowDown } from 'lucide-react';

export const HeroSection = ({ onScrollToCalculator }) => {
  const { t } = useApp();
  
  return (
    <section 
      className="relative min-h-[60vh] flex items-center justify-center py-16 sm:py-24 overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 -left-32 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 -right-32 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl" />
      </div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center">
        {/* Logo */}
        <div className="inline-flex items-center justify-center mb-8">
          <img
  src={process.env.PUBLIC_URL + '/logo.webp'}
  alt="Money Smart - Calculator Dobândă Compusă"
  width="180"
  height="80"
  className="h-20 sm:h-28 w-auto"
/>
        </div>
        
        {/* Subtitle */}
        <p 
          className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto mb-10 leading-relaxed"
          data-testid="hero-subtitle"
        >
          {t('heroSubtitle')}
        </p>
        
        {/* CTA Button */}
        <Button
          size="lg"
          onClick={onScrollToCalculator}
          className="h-12 px-8 rounded-full bg-gradient-to-r from-blue-600 to-emerald-500 hover:from-blue-700 hover:to-emerald-600 text-white font-medium shadow-lg shadow-blue-500/25 hover:shadow-xl hover:shadow-blue-500/30 transition-all duration-300 hover:-translate-y-0.5"
          data-testid="cta-button"
        >
          {t('ctaButton')}
          <ArrowDown className="ml-2 h-4 w-4 animate-bounce" />
        </Button>
      </div>
    </section>
  );
};

export const Header = () => {
  const { t } = useApp();
  
  return (
    <header 
      className="sticky top-0 z-50 w-full bg-background/80 backdrop-blur-xl border-b border-border/40 shadow-sm"
      data-testid="header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center">
          <img 
  src={process.env.PUBLIC_URL + '/logo.webp'} 
  alt="Money Smart" 
  width="140"
  height="50"
  className="h-10 sm:h-12 w-auto"
/>
        </div>
        
        {/* Controls */}
        <div className="flex items-center gap-2">
          <CurrencyToggle />
          <LanguageToggle />
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
};

export default HeroSection;
